import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useSendInvoicesSummary() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  // Évite les setState si le composant est démonté pendant la requête.
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const setStatesIfMounted = (success, loading) => {
    if (!isMountedRef.current) return;
    setIsSuccess(success);
    setIsLoading(loading);
  };

  const sendInvoicesSummary = async (startDate, endDate) => {
    setStatesIfMounted(false, true);
    try {
      const response = await fleetApi.post(
        '/super-admin/send-invoices-summary',
        {
          start_date: startDate,
          end_date: endDate,
        }
      );
      if (response.status === 200) {
        if (response.data?.sent) {
          setStatesIfMounted(true, false);
          toast.success(
            `Récapitulatif envoyé à ${response.data.recipients} Super-Admin pour ${response.data.clients} client(s).`
          );
        } else {
          setStatesIfMounted(false, false);
          toast.info(response.data?.reason || 'Aucun envoi effectué.');
        }
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setStatesIfMounted(false, false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
    }
  };

  return {
    isLoading,
    isSuccess,
    sendInvoicesSummary,
  };
}
